import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import Pagination from "../components/homeComponents/pagination";
import { listStoreCategories } from "../Redux/Actions/CategoryActions";
import "./styles/categories-page.css";

const CategoriesScreen = ({ match }) => {
  const dispatch = useDispatch();

  const pageNumber = Number(match?.params?.pageNumber || 1);
  const categoriesPerPage = 16;

  const categoryStoreList = useSelector((state) => state.categoryStoreList);
  const { loading, error, categories = [] } = categoryStoreList || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(listStoreCategories());
  }, [dispatch, pageNumber]);

  const pages = Math.ceil(categories.length / categoriesPerPage);

  const paginatedCategories = useMemo(() => {
    const start = (pageNumber - 1) * categoriesPerPage;
    return categories.slice(start, start + categoriesPerPage);
  }, [categories, pageNumber]);

  return (
    <>
      <Header />

      <main className="categories-page">
        <div className="site-shell">
          <div className="site-shell-inner">
            <div className="categories-page-header">
              <h2>Nuestras categorías</h2>
              <p>
                Explora nuestras líneas de productos y encuentra más rápido lo
                que necesitas.
              </p>
            </div>

            {loading ? (
              <Loading />
            ) : error ? (
              <Message variant="alert-danger">{error}</Message>
            ) : !categories.length ? (
              <Message variant="alert-info">
                No hay categorías disponibles.
              </Message>
            ) : (
              <>
                <div className="categories-grid">
                  {paginatedCategories.map((cat) => (
                    <Link
                      key={cat._id}
                      to={`/categorias/${cat.slug}`}
                      className="categories-grid-card"
                    >
                      <div className="categories-grid-image">
                        {cat.imageUrl ? (
                          <img src={cat.imageUrl} alt={cat.name} />
                        ) : (
                          <div className="categories-grid-placeholder">
                            {cat.name?.charAt(0)}
                          </div>
                        )}
                      </div>

                      <div className="categories-grid-info">
                        <h3>{cat.name}</h3>
                        {cat.description && <p>{cat.description}</p>}
                      </div>
                    </Link>
                  ))}
                </div>

                <Pagination
                  page={pageNumber}
                  pages={pages}
                  basePath="/categorias"
                />
              </>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default CategoriesScreen;